import dayjs from 'dayjs';

export const APIErrorMessages = (selectedError, additionalInfo) => {
  const errorMessages = {
    ERR_GROUNDTYPE_LINK_PARCEL: {
      fr: `Ce type de sol est utilisé par ${additionalInfo} ${
        additionalInfo > 1 ? 'parcelles' : 'parcelle'
      }`,
      en: `This groundType is used by ${additionalInfo} ${
        additionalInfo > 1 ? 'parcels' : 'parcel'
      }`,
    },
    ERR_CANNOT_TAKEOVER: {
      fr: `La procédure déjà en cours par un autre utilisateur. La procédure a été commence à ${dayjs(
        additionalInfo.started_at
      ).format('HH:mm')} et sera indisponible jusqu'à ${dayjs(additionalInfo.started_at)
        .add(1, 'hour')
        .format('HH:mm')}.`,
      en: `The procedure is already in progress by another user. The procedure has been started at ${dayjs(
        additionalInfo.started_at
      ).format('HH:mm')} and will be unavailable until ${dayjs(additionalInfo.started_at)
        .add(1, 'hour')
        .format('HH:mm')}.`,
    },
    ERR_HAS_BEEN_TAKEN_OVER_STARTED: {
      fr: `Votre limite de temps a été dépassé et la procédure a été commencé par un autre utilisateur ${
        additionalInfo?.user_email
      } à ${dayjs(additionalInfo?.started_at).format('HH:mm')}.`,
      en: `Your time limit has been exceeded and the procedure has been started by another user ${
        additionalInfo?.user_email
      } at ${dayjs(additionalInfo?.started_at).format('HH:mm')}.`,
    },
    ERR_HAS_BEEN_TAKEN_OVER_ENDED: {
      fr: `La procédure a été finalisé par un autre utilisateur ${
        additionalInfo?.user_email
      } à ${dayjs(additionalInfo?.ended_at).format('HH:mm')}.`,
      en: `The procedure has been finalized by another user ${
        additionalInfo?.user_email
      } at ${dayjs(additionalInfo?.ended_at).format('HH:mm')}.`,
    },
  };
  return errorMessages[selectedError];
};

export default APIErrorMessages;
